<script>
import { productService } from "../../services";
import { required } from "vuelidate/lib/validators";
import config from "../../config";
import { error_message, success_message } from "../../Helper/helper";
import Multiselect from "vue-multiselect";
import DropzonePopup from "../../components/widgets/dropzone-popup";

export default {
  components: { productService, Multiselect, DropzonePopup },
  data() {
    return {
      checked: true,
      categories: [],
      subCategories: [],
      brands: [],
      url: null,
      config: config,
      selProduct: [],
      upselProduct: [],
      product: [],
      isLoading: false,
      taxes: [],
      isDisabled:false,
      // category_id: [],
      // selectedCategories:[],
      // groupedSubCategories: [],
      typeform: {
        previousPrice: null,
        category_id: "",
        menu_id: "",
        brand_id: "",
        item_name: "",
        item_name_lang: "",
        item_description: "",
        item_description_lang: "",
        vat: "",
        product_unit: "",
        product_unit_sign: "",
        status: "1",
        ingredients: [{ name: "", value: "" }],
        otherdetails: [{name:'',value:''}],
        selProduct: "",
        unit: "",
        unit_sign: "",
        unit_value: "",
        product_image: [],
        // selectedCategories: "" 
      },
    };
  },
  validations: {
    typeform: {
      category_id: {
        required,
      },
      // selectedCategories: {
      //   required // Adjust validation as needed
      // },
      menu_id: {
        required,
      },
      brand_id: {
        required,
      },
      item_name: {
        required,
      },
      item_name_lang: {
        required,
      },
      vat: {
        required,
      },
      product_unit: {
        required,
      },
      product_unit_sign: {
        required,
      },
      item_description: {
        required,
      },
      item_description_lang: {
        required,
      },
    },
  },
  mounted() {
    this.getTaxes();
    this.getMainCategory();
    this.getProductBrand();
  },
  // watch: {
  //   selectedCategories(newVal) {
  //     if (newVal.length) {
  //       this.getSubCategory();
  //     } else {
  //       this.groupedSubCategories = [];
  //     }
  //   }
  // },
  methods: {
    clearAllCustomer() {
      this.selProduct = [];
    },
    AddField: function () {
      this.typeform.ingredients.push({ name: "", value: "" });
    },
    remove_ingredient(index) {
      this.typeform.ingredients.splice(index, 1);
    },
    AddDetailField: function () {
        this.typeform.otherdetails.push({ name: '',value: ''});
    },
    remove_other_deatil(index){
        this.typeform.otherdetails.splice(index,1);
    },
    getTaxes(){
        productService.getTaxes()
        .then((response) => {
            this.taxes = response.data.result;
            this.taxes.sort((a, b) => a.vat - b.vat);
        });
    },
    floatingNumber(e) {
      const floating = /^[0-9.]\d*(\.\d{1,2})?$/;
      let char = String.fromCharCode(e.keyCode);
      if (floating.test(char)) return true;
      else e.preventDefault();
    },
     handleInput (e) {
      let stringValue = e.target.value.toString()
      let regex = /^\d*(\.\d{1,2})?$/
      if(!stringValue.match(regex) && this.vat!== '') {
        this.vat= this.previousvat
      }
      this.previousvat = this.vat
    },
    // asyncCategory(query) {
    //   this.isLoading = true;
    //   promoCodeService
    //     .getSubcategorySearch({ search: query, category_id: this.category_id })
    //     .then((response) => {
    //       this.searchCategories = response.data.result;
    //       this.isLoading = false;
    //     });
    // },
    addProduct() {
      console.log('test products',this.typeform.selProduct);
      this.$v.typeform.$touch();
      if (this.$v.typeform.$invalid) {
        setTimeout(()=>{
            $('html, body').animate({
                scrollTop: $(".is-invalid:first").offset().top-$('#page-topbar').height()-50
            }, 200, function() {
                $(".is-invalid:first").focus();
            });
        },300);
        return;
      } else {
        this.isDisabled = true;
        const fd = new FormData();
        if (this.typeform.selProduct.length != 0) {
          this.upselProduct = this.typeform.selProduct
            .map((items) => items.id)
            .map((items, index) => {
              fd.append("selProduct[" + index + "]", items);
            });
        }

        var vat = this.typeform.vat.id;
        productService
          .addProduct({ ...this.typeform, product: this.upselProduct,product_vat:vat })
          .then((response) => {
            if (response.data.code === 200) {
              success_message(response.data.message);
              this.$router.push({ name: "product-list" });
            } else {
              error_message(response.data.message);
            }
            this.isDisabled = false;
          });
      }
    },
    getMainCategory() {
      productService.getMainCategory().then((response) => {
        this.categories = response.data.result.sort((a, b) => {
          return a.category_name.localeCompare(b.category_name);
        });
      });
    },
    getSubCategory(event) {
      this.category_id = event.target.value;
      productService
        .getSubCategory({ category_id: this.category_id })
        .then((response) => {
          this.subCategories = response.data.result.sort((a, b) => {
            return a.menu_name.localeCompare(b.menu_name);
          });
        });
    },
    // getSubCategory() {
    //   const categoryIds = this.category_id.map(category => category.id);
    //   productService.getSubCategory({ category_ids: categoryIds }).then((response) => {
    //     this.groupedSubCategories = this.groupSubCategoriesByCategory(response.data.result);
    //   });
    // },
    getProductBrand() {
      productService.getAllProductBrand().then((response) => {
        // this.brands = response.data.result;
        this.brands = response.data.result.sort((a, b) => {
            return a.name.localeCompare(b.name);
          });
      });
    },
    asyncFindCustomer(query) {
      if(query != ''){
        this.isLoading = true;
        productService
        .getSearchProduct({ query, id: "", type: "add" })
        .then((response) => {
          this.product = response.data.result.sort((a, b) => {
            return a.item_name.localeCompare(b.item_name);
          });
          this.isLoading = false;
        });
      } 
    },
    alphabetic(e) {
      const floating = /^[A-Za-z ]+$/;
      let char = String.fromCharCode(e.keyCode);
      if (floating.test(char)) return true;
      else e.preventDefault();
    },
    // groupSubCategoriesByCategory(subCategories) {
    //   const grouped = {};
    //   subCategories.forEach(subCategory => {
    //     if (!grouped[subCategory.category_name]) {
    //       grouped[subCategory.category_name] = {
    //         name: subCategory.category_name,
    //         id: subCategory.category_id,
    //         subCategories: []
    //       };
    //     }
    //     grouped[subCategory.category_name].subCategories.push(subCategory);
    //   });
    //   return Object.values(grouped);
    // }
  },
};
</script>
<template>
  <form @submit.prevent="addProduct">
    <div class="card">
      <div class="card-body">
        <p class="card-title-desc"></p>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="required">{{
                trans.trans("__JSON__.Category")
              }}</label>
              <select
                class="custom-select"
                v-model="$v.typeform.category_id.$model"
                id="category_id"
                name="category_id"
                @change="getSubCategory($event)"
                :class="{ 'is-invalid': $v.typeform.category_id.$error }"
              >
                <option value="">
                  {{ trans.get("__JSON__.Select Category") }}
                </option>
                <option
                  v-for="cat in categories"
                  :value="cat.category_id"
                  :key="cat.category_id"
                >
                  {{ cat.category_name }}
                </option>
              </select>
              <div
                v-if="$v.typeform.category_id.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.typeform.category_id.required">{{
                  trans.get("__JSON__.Please select category")
                }}</span>
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label class="required">{{
                trans.trans("__JSON__.Sub Category")
              }}</label>
              <select
                class="custom-select"
                v-model="$v.typeform.menu_id.$model"
                id="menu_id"
                name="menu_id"
                :class="{ 'is-invalid': $v.typeform.menu_id.$error }"
              >
                <option value="">
                  {{ trans.get("__JSON__.Select Sub Category") }}
                </option>
                <option
                  v-for="sub in subCategories"
                  :value="sub.id"
                  :key="sub.id"
                >
                  {{ sub.menu_name }}
                </option>
              </select>
              <div v-if="$v.typeform.menu_id.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.menu_id.required">{{
                  trans.get("__JSON__.Please select category")
                }}</span>
              </div>
            </div>
          </div>

          <!-- <div class="search-box mr-2">
                <div class="position-relative">
                  <multiselect
                    v-model="$v.typeform.category_id.$model"
                    id="category_id"
                    label="category_name"
                    track-by="category_id"
                    :placeholder="trans.get('__JSON__.Category')"
                    open-direction="bottom"
                    :options="categories"
                    :multiple="true"
                    :searchable="true"
                    :loading="isLoading"
                    :internal-search="true"
                    :clear-on-select="true"
                    :close-on-select="false"
                    :max-height="600"
                    :show-no-results="false"
                    :hide-selected="true"
                    @search-change="asyncCategory"
                    @input="getSubCategory"
                    :class="{ 'is-invalid': $v.typeform.category_id.$error }"
                  >
                    <template slot="tag" slot-scope="{ option, remove }">
                      <span class="custom__tag">
                        <span>{{ option.category_name }}</span>
                        <span class="custom__remove" @click="remove(option)">❌</span>
                      </span>
                    </template>
                    <template slot="clear" slot-scope="props">
                      <div
                        class="multiselect__clear"
                        v-if="category_id.length"
                        @mousedown.prevent.stop="clearAll(props.search)"
                      ></div>
                    </template>
                    <span slot="noResult">
                      {{
                        trans.get(
                          "__JSON__.Oops! No elements found. Consider changing the search query"
                        )
                      }}.
                    </span>
                  </multiselect>
                  <div v-if="$v.typeform.category_id.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.category_id.required">
                      {{ trans.get("__JSON__.Please select category") }}.
                    </span>
                  </div>
                </div>
                </div>

          </div>


          <div class="col-sm-6">
  <div class="form-group">
    <label class="required">{{ trans.trans("__JSON__.Sub Category") }}</label>
    <select
      class="custom-select"
      v-model="typeform.menu_id"
      id="menu_id"
      name="menu_id"
      :class="{ 'is-invalid': $v.typeform.menu_id.$error }"
    >
      <option value="">
        {{ trans.get("__JSON__.Select Sub Category") }}
      </option>
      <optgroup v-for="category in groupedSubCategories" :label="category.name" :key="category.id">
        <option
          v-for="sub in category.subCategories"
          :value="sub.id"
          :key="sub.id"
        >
          {{ sub.menu_name }}
        </option>
      </optgroup>
    </select>
    <div v-if="$v.typeform.menu_id.$error" class="invalid-feedback">
      <span v-if="!$v.typeform.menu_id.required">
        {{ trans.get("__JSON__.Please select sub category") }}
      </span>
    </div>
  </div>
</div> -->

          <div class="col-sm-6" v-if="$auth.setting">
            <div class="form-group">
              <label class="required">{{
                trans.trans("__JSON__.Product Name Primary", {
                  lang: $auth.langauges[0].name,
                })
              }}</label>
              <input
                id="item_name"
                v-model="$v.typeform.item_name.$model"
                type="text"
                class="form-control"
                :placeholder="
                  trans.trans('__JSON__.Product Name Primary', {
                    lang: $auth.langauges[0].name,
                  })
                "
                name="item_name"
                :class="{ 'is-invalid': $v.typeform.item_name.$error }"
              />
              <div v-if="$v.typeform.item_name.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.item_name.required">{{
                  trans.get("__JSON__.Please enter product name")
                }}</span>
              </div>
            </div>
          </div>

          <div
            class="col-sm-6"
            v-if="$auth.langauges[1].name !== 'No Secondary Language'"
          >
            <div class="form-group">
              <label class="required">{{
                trans.trans("__JSON__.Product Name Secondary", {
                  lang: $auth.langauges[1].name,
                })
              }}</label>
              <input
                id="item_name_lang"
                v-model="$v.typeform.item_name_lang.$model"
                type="text"
                class="form-control"
                :placeholder="
                  trans.trans('__JSON__.Product Name Secondary', {
                    lang: $auth.langauges[1].name,
                  })
                "
                name="item_name_lang"
                :class="{ 'is-invalid': $v.typeform.item_name_lang.$error }"
              />
              <div
                v-if="$v.typeform.item_name_lang.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.typeform.item_name_lang.required">{{
                  trans.get("__JSON__.Please enter product name")
                }}</span>
              </div>
            </div>
          </div>

          <div class="col-sm-6" v-if="$auth.setting">
            <div class="form-group">
              <label class="required">{{
                trans.trans("__JSON__.Product Description Primary", {
                  lang: $auth.langauges[0].name,
                })
              }}</label>

              <textarea
                rows="5"
                id="item_description"
                type="text"
                class="form-control"
                v-model="$v.typeform.item_description.$model"
                :placeholder="
                  trans.trans('__JSON__.Product Description Primary', {
                    lang: $auth.langauges[0].name,
                  })
                "
                name="item_description"
                :class="{ 'is-invalid': $v.typeform.item_description.$error }"
              >
              </textarea>

              <div
                v-if="$v.typeform.item_description.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.typeform.item_description.required">{{
                  trans.get("__JSON__.Please enter product description")
                }}</span>
              </div>
            </div>
          </div>

          <div
            class="col-sm-6"
            v-if="$auth.langauges[1].name !== 'No Secondary Language'"
          >
            <div class="form-group">
              <label class="required">{{
                trans.trans("__JSON__.Product Description Secondary", {
                  lang: $auth.langauges[1].name,
                })
              }}</label>
              <textarea
                rows="5"
                id="item_description_lang"
                type="text"
                class="form-control"
                v-model="$v.typeform.item_description_lang.$model"
                :placeholder="
                  trans.trans('__JSON__.Product Description Secondary', {
                    lang: $auth.langauges[1].name,
                  })
                "
                name="item_description_lang"
                :class="{
                  'is-invalid': $v.typeform.item_description_lang.$error,
                }"
              >
              </textarea>
              <div
                v-if="$v.typeform.item_description_lang.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.typeform.item_description_lang.required">{{
                  trans.get("__JSON__.Please enter product description")
                }}</span>
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label class="required">{{
                trans.trans("__JSON__.Brand")
              }}</label>
              <select
                class="custom-select"
                v-model="$v.typeform.brand_id.$model"
                id="brand_id"
                name="brand_id"
                :class="{ 'is-invalid': $v.typeform.brand_id.$error }"
              >
                <option value="">
                  {{ trans.get("__JSON__.Select Brand") }}
                </option>
                <option
                  v-for="brand in brands"
                  :value="brand.id"
                  :key="brand.id"
                >
                  {{ brand.name }}
                </option>
              </select>
              <div v-if="$v.typeform.brand_id.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.brand_id.required">{{
                  trans.get("__JSON__.Please select brand")
                }}</span>
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label class="required">{{ trans.trans("__JSON__.Tax") }}</label>
               <multiselect
                  v-model="$v.typeform.vat.$model"
                  id="tax"
                  label="vat"
                  track-by="id"
                  :placeholder="trans.get('__JSON__.Tax')"
                  open-direction="bottom"
                  :options="taxes"
                  :multiple="false"
                  :close-on-select="true"
                  :clear-on-select="true"
                  :max-height="600"
                  :show-no-results="false"
                  :hide-selected="true"
                  :class="{ 'is-invalid': $v.typeform.vat.$error }"
                  >
                  <span
                  slot="noResult"
                  >{{ trans.get('__JSON__.Oops! No elements found. Consider changing the search query') }}.</span>
              </multiselect>
              <div v-if="$v.typeform.vat.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.vat.required">{{
                  trans.get("__JSON__.Please enter tax")
                }}</span>
              </div>
            </div>
          </div>
        
          <div class="col-sm-6">
            <div class="form-group">
              <label class="required">{{ trans.trans("__JSON__.Product Unit") }}</label>
              <input
                id="product_unit"
                v-model="$v.typeform.product_unit.$model"
                type="text"
                :maxlength="15"
                class="form-control"
                :placeholder="trans.trans('__JSON__.Product Unit')"
                name="product_unit"
                :class="{ 'is-invalid': $v.typeform.product_unit.$error }"
                v-on:keypress="alphabetic($event, typeform.product_unit)"
              />
              <div v-if="$v.typeform.product_unit.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.product_unit.required">{{
                  trans.get("__JSON__.Please enter product unit")
                }}</span>
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label class="required">{{ trans.trans("__JSON__.Product Unit Sign") }}</label>
              <input
                id="product_unit_sign"
                v-model="$v.typeform.product_unit_sign.$model"
                type="text"
                :maxlength="5"
                class="form-control"
                :placeholder="trans.trans('__JSON__.Product Unit Sign')"
                name="product_unit_sign"
                :class="{ 'is-invalid': $v.typeform.product_unit_sign.$error }"
                v-on:keypress="alphabetic($event, typeform.product_unit_sign)"
              />
              <div v-if="$v.typeform.product_unit_sign.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.product_unit_sign.required">{{
                  trans.get("__JSON__.Please enter product unit sign")
                }}</span>
              </div>
            </div>
          </div>

          <div class="col-sm-6 vendor-status">
            <b-form-group
              id="input-group-1"
              :label="trans.get('__JSON__.Status')"
              label-for="status"
            >
              <label class="switch">
                <input
                  type="checkbox"
                  id="togBtn"
                  name="status"
                  v-model="typeform.status"
                  class="switch-on"
                  true-value="1"
                  false-value="0"
                />
                <div class="slider round">
                  <span class="on">{{ trans.get("__JSON__.Active") }}</span>
                  <span class="off">{{ trans.get("__JSON__.Inactive") }}</span>
                </div>
              </label>
            </b-form-group>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <h4 class="card-title">
          {{ trans.get("__JSON__.Product Ingredients") }}
        </h4>
        <p class="card-title-desc"></p>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label>{{
                trans.trans("__JSON__.Unit (liter/kilogram)")
              }}</label>
              <input
                id="unit"
                v-model="typeform.unit"
                type="text"
                class="form-control"
                :placeholder="trans.trans('__JSON__.Unit (liter/kilogram)')"
                name="unit"
                v-on:keypress="alphabetic($event, typeform.unit)"
              />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>{{
                trans.trans("__JSON__.Unit Value(1/1.5)")
              }}</label>
              <input
                id="unit_value"
                v-model="typeform.unit_value"
                type="text"
                class="form-control"
                :placeholder="trans.trans('__JSON__.Unit Value(1/1.5)')"
                name="unit_value"
                v-on:keypress="floatingNumber($event, typeform.unit_value)"
              />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>{{
                trans.trans("__JSON__.Unit Sign(l/kg)")
              }}</label>
              <input
                id="unit_sign"
                v-model="typeform.unit_sign"
                type="text"
                class="form-control"
                :placeholder="trans.trans('__JSON__.Unit Sign(l/kg)')"
                name="unit_sign"
                v-on:keypress="alphabetic($event, typeform.unit_sign)"
              />
            </div>
          </div>
        </div>

        <div
          class="row"
          v-for="(v, i) in typeform.ingredients"
          :key="i"
        >
          <div class="col-sm-4">
            <div class="form-group">
              <label>{{
                trans.trans("__JSON__.Ingredient Name")
              }}</label>
              <input
                id="name"
                v-model="v.name"
                type="text"
                class="form-control"
                :placeholder="trans.trans('__JSON__.Ingredient Name')"
                name="name[]"
              />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>{{
                trans.trans("__JSON__.Ingredient Value")
              }}</label>
              <input
                id="value"
                v-model="v.value"
                type="text"
                class="form-control"
                :placeholder="trans.trans('__JSON__.Ingredient Value')"
                name="value[]"
              />
            </div>
          </div>
          <div class="col-md-3">
            <h6>&nbsp;</h6>
            <button
              class="btn btn-primary btn-sm btn-rounded"
              @click.prevent="AddField()"
            >
              +</button
            >&nbsp;&nbsp;
            <button
              class="btn btn-danger btn-sm btn-rounded"
              v-if="i != 0"
              @click.prevent="remove_ingredient(i)"
            >
              -
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <h4 class="card-title">
          {{ trans.get("__JSON__.Product Other Details") }}
        </h4>
        <p class="card-title-desc"></p>
        <div
          class="row"
          v-for="(v, i) in typeform.otherdetails"
          :key="i"
        >
          <div class="col-sm-4">
            <div class="form-group">
              <label>{{
                trans.trans("__JSON__.Name")
              }}</label>
              <input
                id="name"
                v-model="v.name"
                type="text"
                class="form-control"
                :placeholder="trans.trans('__JSON__.Name')"
                name="name[]"
              />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>{{
                trans.trans("__JSON__.Value")
              }}</label>
              <input
                id="value"
                v-model="v.value"
                type="text"
                class="form-control"
                :placeholder="trans.trans('__JSON__.Value')"
                name="value[]"
              />
            </div>
          </div>
          <div class="col-md-3">
            <h6>&nbsp;</h6>
            <button
              class="btn btn-primary btn-sm btn-rounded"
              @click.prevent="AddDetailField"
            >
              +</button
            >&nbsp;&nbsp;
            <button
              class="btn btn-danger btn-sm btn-rounded"
              v-if="i != 0"
              @click.prevent="remove_other_deatil(i)"
            >
              -
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <h4 class="card-title">
          {{ trans.get("__JSON__.Upselling Products") }}
        </h4>
        <p class="card-title-desc"></p>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <multiselect
                v-model="typeform.selProduct"
                id="ajax"
                label="item_name"
                track-by="item_name"
                :placeholder="trans.get('__JSON__.Type to Search Product')"
                open-direction="bottom"
                :options="product"
                :multiple="true"
                :searchable="true"
                :loading="isLoading"
                :internal-search="true"
                :clear-on-select="true"
                :close-on-select="false"
                :max-height="600"
                :show-no-results="false"
                :hide-selected="true"
                @search-change="asyncFindCustomer"
              >
                <template slot="tag" slot-scope="{ option, remove }">
                  <span class="custom__tag">
                    <span>{{ option.item_name }}</span>
                    <span class="custom__remove" @click="remove(option)"
                      >❌</span
                    >
                  </span>
                </template>
                <template slot="clear" slot-scope="props">
                  <div
                    class="multiselect__clear"
                    v-if="selProduct.length"
                    @mousedown.prevent.stop="clearAll(props.search)"
                  ></div>
                </template>
                <span slot="noResult"
                  >{{
                    trans.get(
                      "__JSON__.Oops! No elements found. Consider changing the search query"
                    )
                  }}.</span
                >
              </multiselect>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <button class="btn btn-primary mr-1 mt-3" :disabled="isDisabled">
              {{ trans.get("__JSON__.Add Product") }}
            </button>
            <router-link
              :to="{name:'product-list'}"
            >
              <b-button
                type="button"
                variant="secondary"
                class="mt-3"
                >{{ trans.get("__JSON__.Cancel") }}</b-button
              >
            </router-link>  
          </div>
        </div>
      </div>
    </div>
  </form>
</template>